
import React, { Component, useEffect, useRef, useState } from 'react'
import CKEditor from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { withStyles } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';

const useStylesRich = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    basicDetailWrp:{
        margin: '1rem 0 2rem 0',
        padding: '1rem',
        background: '#fff'
    },
    title:{
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1.25rem',
        margin: '0 0 2rem 0', 
        textAlign: 'left',
        color:"#333",
      },
    fieldsetBox:{
        marginBottom:theme.spacing(1),
        border: 0,
        padding: 0,
        background: 'transparent',
        '& label':{
            fontFamily: 'VodafoneRg-bold', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            display:'block',
        },
        '& input[type="text"],input[type="date"],select ':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '3rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
        },
        '& input[type=date]:before':{content:'none'},
        '& textarea':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '8.5rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            resize:'none'
        },
        
        
        
    },
    '& input[aria-invalid="true"]':{
        borderColor:'red',
    },
    error:{
        color:"red",
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1rem',
        margin: '0 0 0.5rem 0', 
    },
    labelname:{
        fontFamily: 'VodafoneRg-bold', 
        fontSize: '1rem',
        margin: '0 0 0.5rem 0', 
        textAlign: 'left',
        color:"#333",
        display:'block',
    },
    
    invalid: {
        borderColor: 'red !important',
    },
    content: {
        fontWeight: '400',
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1rem',
        margin: '0 0 1rem 0', 
        color:"#333",
      },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  }));



const RichTextEditor = (props) => {
    // alert("enter ")
    const classes = useStylesRich();
    const { value, onChange,placeholder } = props || {}

    const editorConfig = {
        toolbar: ['bold', 'italic', 'link', 'bulletedList', 'numberedList', 'underline', 'fontColor'],

        // toolbar: [
        //     'heading', 'bold', 'italic', 'underline', 'strikethrough',
        //     'link', 'bulletedList', 'numberedList', 'blockQuote',
        //     'insertTable', 'undo', 'redo', 'alignment', 'fontColor',
        //     'fontBackgroundColor', 'fontSize', 'highlight'
        //   ],

    }
    const handleOnChange = (event, editor) => {
        const getvalue = editor.getData()
        onChange(getvalue)
    }

    return (
       
        <div className={classes.content}>
            <CKEditor
                config={editorConfig}
                editor={ClassicEditor}
                data={value}
                onChange={handleOnChange}
                placeholder={placeholder}
                onInit={editor => console.log("rich editot", editor)}
            />
            
        </div>
    )
}

export default RichTextEditor

